import { render, staticRenderFns } from "./PosterGraphql.vue?vue&type=template&id=11d06be6"
import script from "./PosterGraphql.vue?vue&type=script&setup=true&lang=ts"
export * from "./PosterGraphql.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PosterGraphql.vue?vue&type=style&index=0&id=11d06be6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports